import React, { useEffect, useState, useContext } from "react";
import { Avatar, Typography, Row, Col, Button, message, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import View from "../../assets/images/Fill.png";
import IconView from "../../assets/images/IconView.svg";
import IconOrder from "../../assets/images/shopping.svg";
import IconShare from "../../assets/images/Shape.svg";
import ICKichhoat from "../../assets/images/kichhoat.svg";
import FileAttach from "../../assets/images/file-attach.svg";
import ViewImageAndFile from "./../../components/common/ViewImageAndFile.jsx";
import Arrows from '../../assets/images/arrow-chevron-left.png';
import Service from "./../../utils/apiOpen";
import Helper from "./../../utils/helper";
import { LocalState } from "./index";


const OrderDetail = () => {
    const { detailOrder, setDetailOrder, StatusWidget, goStep } = useContext(LocalState);
    // Thông tin đơn hàng
    const [orderInformation, setOrderInformation] = useState([]);
    // Hiển thị phần người mua bảo hiểm
    const [showBuyer, setShowBuyer] = useState(false);
    // Thông tin chi tiết người được bảo hiểm
    const [insuredInformation, setInsuredInformation] = useState([]);
    // Danh sách người được bảo hiểm cho những sản phẩm mua nhiều người.
    const [insuredPeoples, setInsuredPeoples] = useState([]);
    // Hiện người đồng sở hữu căn nhà cho bảo hiểm nhà tư nhân
    const [showOwnership, setShowOwnership] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getDetail();
    }, []);


    useEffect(() => {
        if (detailOrder?.productCode === 'nha') {
            // Phân biệt providerID cho bảo hiểm nhà  3 là PVI vào Home Care, còn lại là nhà tư nhân
            if (detailOrder?.providerId === 3) {
                OrderInformation('home-care');
            } else {
                OrderInformation('nha-tu-nhan');
            }
        } else {
            OrderInformation(detailOrder?.productCode);
        }
    }, [detailOrder]);

    const getDetail = async () => {
        setLoading(true);
        const data = {
            orderCode: detailOrder?.orderCode,
            productCode: detailOrder?.productCode,
            providerId: detailOrder?.providerId
        }
        await Service.openApiCall("GET", `/v1/affiliate/portal/orders/view`, data)
            .then((res) => {
                setLoading(false);
                let data = res?.data;
                if (data.success) {
                    setDetailOrder({ ...detailOrder, ...data?.data });
                    localStorage.setItem('dataDetailOrderAff', JSON.stringify({ ...detailOrder, ...data?.data }));
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err?.response) {
                    message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
                }
            });
    };

    // Hiển thị thông tin đơn hàng theo từng sản phẩm
    const OrderInformation = (product) => {
        switch (product) {
            case 'family_care': // Sản phẩm tạm dừng
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
                ])
                setShowBuyer(true);
                // Danh sách người được bảo hiểm
                setInsuredPeoples(detailOrder?.insuredPeople);
                setInsuredInformation([
                    { title: 'Họ và tên', key: 'insuredName', colValue: 5, capitalize: true },
                    { title: 'Ngày sinh', key: 'insuredDob', colValue: 5, },
                    { title: 'Giới tính', key: 'insuredGender', colValue: 5 },
                    { title: 'CCCD / hộ chiếu', key: 'insuredPrivateId', colValue: 5 },
                    { title: 'Số điện thoại', key: 'insuredPhone', colValue: 4 },
                    { title: 'Mối quan hệ', key: 'relationshipWithBuyerName', colValue: 5 },
                    { title: 'Email', key: 'insuredEmail', colValue: 5, },
                    { title: 'Địa chỉ', key: 'insuredAddress', colValue: 10 },
                ])
                break;
            case 'bhn': // đã xong
                // Bệnh hiểm nghèo
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5, },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
                ])
                setShowBuyer(true);
                setInsuredPeoples(detailOrder?.insuredPeople);
                setInsuredInformation([
                    { title: 'Họ và tên', key: 'insuredName', colValue: 5 },
                    { title: 'Ngày sinh', key: 'insuredDob', colValue: 5, },
                    { title: 'Giới tính', key: 'insuredGender', colValue: 5 },
                    { title: 'CCCD / hộ chiếu', key: 'insuredPrivateId', colValue: 5 },
                    { title: 'Số điện thoại', key: 'insuredPhone', colValue: 4 },
                    { title: 'Mối quan hệ', key: 'relationshipWithBuyerTitle', colValue: 5 },
                    { title: 'Email', key: 'insuredEmail', colValue: 5, },
                    { title: 'Địa chỉ', key: 'insuredAddress', colValue: 10 },
                ])
                break;
            // case 'sk': // chưa có trong thiết kế
            //     setOrderInformation([
            //         { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
            //         { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
            //         { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
            //         { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
            //         { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
            //     ])
            //     setShowBuyer(true);
            //     // Danh sách người được bảo hiểm
            //     setInsuredPeoples(detailOrder?.insuredPeople);
            //     setInsuredInformation([
            //         { title: 'Họ và tên', key: 'insuredName', colValue: 5, capitalize: true },
            //         { title: 'Ngày sinh', key: 'insuredDob', colValue: 5, },
            //         { title: 'Giới tính', value: 'insuredGender', colValue: 5 },
            //         { title: 'CCCD / hộ chiếu', value: 'insuredPrivateId', colValue: 5 },
            //         { title: 'Số điện thoại', value: 'insuredPhone', colValue: 4 },
            //         { title: 'Mối quan hệ', value: 'relationshipWithBuyerName', colValue: 5 },
            //         { title: 'Email', value: 'insuredEmail', colValue: 5, },
            //         { title: 'Địa chỉ', value: 'insuredAddress', colValue: 10 },
            //     ])
            //     break;
            case 'bbxm': // đã xong
                //TNDS bắt buộc xe máy
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Bảo hiểm TNNNTX', value: detailOrder?.orderInfo?.tnnntx, colValue: 5 },
                    { title: 'Công ty bảo hiểm', value: detailOrder?.orderInfo?.providerTitle, colValue: 4 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 }
                ])
                setInsuredInformation([
                    { title: 'Biển số xe', value: detailOrder?.vehicleInfo?.license, colValue: 5 },
                    { title: 'Số khung xe', value: detailOrder?.vehicleInfo?.chassis, colValue: 5, },
                    { title: 'Số máy xe', value: detailOrder?.vehicleInfo?.engine, colValue: 5 },
                    { title: 'Họ và tên chủ xe', value: detailOrder?.vehicleInfo?.buyerName, colValue: 5, capitalize: true },
                    { title: 'Số điện thoại', value: detailOrder?.vehicleInfo?.buyerPhone, colValue: 4 },
                    { title: 'Email', value: detailOrder?.vehicleInfo?.buyerEmail, colValue: 5, },
                    { title: 'Địa chỉ', value: detailOrder?.vehicleInfo?.buyerAddress, colValue: 10, capitalize: true },
                ])
                break;
            case 'bbot': // đã xong
                // TNDS Bắt Buộc Ô tô
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5, },
                    { title: 'Loại xe', value: detailOrder?.orderInfo?.typeVehicle, colValue: 5 },
                    { title: 'Mục đích sử dụng', value: detailOrder?.orderInfo?.vehicleUsagePurpose, colValue: 5 },
                    { title: 'Số chỗ ngồi / Trọng tải', value: detailOrder?.orderInfo?.numberOfSeatsOrTonnageName, colValue: 4 },
                    { title: 'Trọng tải thực tế (kg)', value: detailOrder?.orderInfo?.numberOfTonnageOnCavet, colValue: 5 },
                    { title: 'Bảo hiểm TNNNTX', value: detailOrder?.orderInfo?.tnnntx, colValue: 5 },
                    { title: 'Số chỗ mua BH', value: detailOrder?.orderInfo?.insuredSeatCount, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.yearsOfInsurance + ' năm', colValue: 5 },
                    { title: 'Công ty bảo hiểm', value: detailOrder?.orderInfo?.providerTitle, colValue: 4 },
                    { title: 'Ngày hiệu lực', value: detailOrder?.orderInfo?.insuranceBegin, colValue: 5 },
                    { title: 'Ngày kết thúc', value: detailOrder?.orderInfo?.insuranceEnd, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 5 }
                ]);
                setInsuredInformation([
                    { title: 'Biển số xe', value: detailOrder?.vehicleInfo?.license, colValue: 5 },
                    { title: 'Số khung xe', value: detailOrder?.vehicleInfo?.chassis, colValue: 5, },
                    { title: 'Số máy xe', value: detailOrder?.vehicleInfo?.engine, colValue: 5 },
                    { title: 'Họ và tên chủ xe', value: detailOrder?.vehicleInfo?.buyerName, colValue: 5, capitalize: true },
                    { title: 'Số điện thoại', value: detailOrder?.vehicleInfo?.buyerPhone, colValue: 4 },
                    { title: 'Email', value: detailOrder?.vehicleInfo?.buyerEmail, colValue: 5, },
                    { title: 'Địa chỉ', value: detailOrder?.vehicleInfo?.buyerAddress, colValue: 5, capitalize: true },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.vehicleInfo?.buyerPrivateId, colValue: 5 },
                ]);
                break;
            case 'tnhgd': // đã xong
                // Tai nạn hộ gia đình
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
                ])
                setInsuredInformation([
                    { title: 'Họ và tên', value: detailOrder?.buyerInfo?.buyerName, colValue: 5, capitalize: true },
                    { title: 'Ngày sinh', value: detailOrder?.buyerInfo?.buyerDob, colValue: 5, },
                    { title: 'Giới tính', value: detailOrder?.buyerInfo?.buyerGender, colValue: 5 },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.buyerInfo?.buyerPrivateId, colValue: 5 },
                    { title: 'Số điện thoại', value: detailOrder?.buyerInfo?.buyerPhone, colValue: 4 },
                    { title: 'Email', value: detailOrder?.buyerInfo?.buyerEmail, colValue: 5, },
                    { title: 'Địa chỉ', value: detailOrder?.buyerInfo?.buyerAddress, colValue: 5, capitalize: true },
                    { title: 'Người được bảo hiểm', value: detailOrder?.orderInfo?.numberOfPeopleInFamily, colValue: 5 },
                    { title: 'Chú ý: Danh sách người được bảo hiểm theo mục “Thông tin cư trú” tại VNeID của chủ hộ.', colValue: 24, showNote: true },
                ])
                break;
            case 'tncn': // đã xong
                // Tai nạn cá nhân
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5, },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
                ]);
                setShowBuyer(true);
                // Danh sách người được bảo hiểm
                setInsuredPeoples(detailOrder?.insuredPeople);
                setInsuredInformation([
                    { title: 'Họ và tên', key: 'insuredName', colValue: 4, capitalize: true },
                    { title: 'Mối quan hệ', key: 'relationshipWithBuyerName', colValue: 4, },
                    { title: 'Ngày sinh', key: 'insuredDob', colValue: 4 },
                    { title: 'CCCD / hộ chiếu', key: 'insuredPrivateId', colValue: 4 },
                    { title: 'Số điện thoại', key: 'insuredPhone', colValue: 4 },
                    { title: 'Email', key: 'insuredEmail', colValue: 4, }
                ])
                break;
            case 'tomato': // đã xong
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 }
                ])
                setInsuredInformation([
                    { title: 'Họ và tên', value: detailOrder?.insuredPeople?.insuredName, colValue: 4 },
                    { title: 'Ngày sinh', value: detailOrder?.insuredPeople?.insuredDob, colValue: 4 },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.insuredPeople?.insuredPrivateId, colValue: 4 },
                    { title: 'Số điện thoại', value: detailOrder?.insuredPeople?.insuredPhone, colValue: 4 },
                    { title: 'Email', value: detailOrder?.insuredPeople?.insuredEmail, colValue: 4, },
                    { title: 'Địa chỉ', value: detailOrder?.insuredPeople?.insuredAddress, colValue: 4 },
                ]);
                break;
            case 'vcoto': // đã xong
                // Vật chất Ô tô
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', key: 'productTitle', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Công ty bảo hiểm', value: detailOrder?.orderInfo?.providerTitle, colValue: 5 },
                    { title: 'Tình trạng xe', value: detailOrder?.orderInfo?.vehicleCondition, colValue: 5 },
                    { title: 'Loại xe', value: detailOrder?.orderInfo?.typeVehicle, colValue: 4 },
                    { title: 'Mục đích sử dụng', value: detailOrder?.orderInfo?.vehicleUsagePurpose, colValue: 5 },
                    { title: 'Năm sản xuất', value: detailOrder?.orderInfo?.yearOfManufacture, colValue: 5 },
                    { title: 'Giá trị xe tham gia bảo hiểm', value: Helper.formatMoney(detailOrder?.orderInfo?.priceForInsurance), colValue: 5 },
                    { title: 'Biển số xe', value: detailOrder?.orderInfo?.license, colValue: 5 },
                    { title: 'Số khung xe', value: detailOrder?.orderInfo?.chassis, colValue: 4 },
                    { title: 'Số máy xe', value: detailOrder?.orderInfo?.engine, colValue: 5 },
                    { title: 'Hiệu xe', value: detailOrder?.orderInfo?.vehicleBrand, colValue: 5 },
                    { title: 'Dòng xe', value: detailOrder?.orderInfo?.vehicleModel, colValue: 5 },
                    { title: 'Số chỗ ngồi của xe', value: detailOrder?.orderInfo?.numberOfSeatsOnCavet, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 4 },
                    { title: 'Bảo hiểm TNDS BB ô tô', value: detailOrder?.orderInfo?.tndsbboto, colValue: 5 },
                    { title: 'Bảo hiểm TNNNTX', value: detailOrder?.orderInfo?.tnnntx, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 5 },
                    {
                        title: 'Tài liệu đính kèm',
                        value: FileViewAndImage('link', detailOrder?.orderInfo?.certificate),
                        colValue: 9
                    },
                    {
                        title: 'Quyền lợi bổ sung',
                        value: FileViewAndImage('additionalBenefits', detailOrder?.orderInfo?.additional),
                        colValue: 24
                    }
                ])
                setInsuredInformation([
                    { title: 'Họ và tên chủ xe', value: detailOrder?.buyerInfo?.buyerName, colValue: 4, capitalize: true },
                    { title: 'Số điện thoại', value: detailOrder?.buyerInfo?.buyerPhone, colValue: 4 },
                    { title: 'Email', value: detailOrder?.buyerInfo?.buyerEmail, colValue: 4, },
                    { title: 'Tỉnh/thành phố', value: detailOrder?.buyerInfo?.provinceTitle, colValue: 4, capitalize: true },
                    { title: 'Quận/huyện', value: detailOrder?.buyerInfo?.districtTitle, colValue: 4, capitalize: true },
                    { title: 'Địa chỉ', value: detailOrder?.buyerInfo?.buyerAddress, colValue: 4, capitalize: true },
                ])
                break;
            case 'master_rider': // đã xong
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Công ty bảo hiểm', value: detailOrder?.orderInfo?.providerTitle, colValue: 5 },
                    { title: 'Loại xe', value: detailOrder?.orderInfo?.typeVehicle, colValue: 4 },
                    { title: 'Hãng xe', value: detailOrder?.orderInfo?.vehicleBrand, colValue: 5 },
                    { title: 'Dòng xe', value: detailOrder?.orderInfo?.vehicleModel, colValue: 5 },
                    { title: 'Năm sản xuất', value: detailOrder?.orderInfo?.yearOfManufacture, colValue: 5 },
                    { title: 'Giá trị xe trung bình ước tính', value: detailOrder?.orderInfo?.priceForInsurance, colValue: 5 },
                    { title: 'Chương trình tham gia', value: detailOrder?.orderInfo?.packageName, colValue: 4 },
                    { title: 'Dịch vụ cứu hộ xe máy 24/7', value: "-", colValue: 5 },
                    { title: 'Bảo hiểm TNDS BB xe máy', value: detailOrder?.orderInfo?.tndsbboto, colValue: 5 },
                    { title: 'Bảo hiểm TNNNTX', value: detailOrder?.orderInfo?.tnnntx, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue:5  },
                    { title: 'Biển số xe', value: detailOrder?.orderInfo?.license, colValue: 4 },
                    { title: 'Số máy xe', value: detailOrder?.orderInfo?.engine, colValue: 5 },
                    { title: 'Số khung xe', value: detailOrder?.orderInfo?.chassis, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 5 },
                ])
                setInsuredInformation([
                    { title: 'Họ và tên chủ xe', value: detailOrder?.buyerInfo?.buyerName, colValue: 5 },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.buyerInfo?.buyerPrivateId, colValue: 5 },
                    { title: 'Số điện thoại', value: detailOrder?.buyerInfo?.buyerPhone, colValue: 5, },
                    { title: 'Email', value: detailOrder?.buyerInfo?.buyerEmail, colValue: 5 },
                    { title: 'Địa chỉ', value: detailOrder?.buyerInfo?.buyerAddress, colValue: 4 },
                ])
                break;
            case 'vbi-care': // chưa có đơn lỗi nhà bảo hiểm
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 },
                    {
                        title: 'Quyền lợi bổ sung',
                        value: FileViewAndImage('additionalBenefits', detailOrder?.orderInfo?.additional),
                        colValue: 24
                    }
                ]);
                setShowBuyer(true);
                // Danh sách người được bảo hiểm
                setInsuredPeoples(detailOrder?.insuredPeople);
                setInsuredInformation([
                    { title: 'Họ và tên', key: 'insuredName', colValue: 5 },
                    { title: 'Ngày sinh', key: 'insuredDob', colValue: 5 },
                    { title: 'Giới tính', key: 'insuredGender', colValue: 5, },
                    { title: 'CCCD / hộ chiếu', key: 'insuredPrivateId', colValue: 5 },
                    { title: 'Số điện thoại', key: 'insuredPhone', colValue: 4 },
                    { title: 'Mối quan hệ', key: 'relationshipWithBuyerName', colValue: 5 },
                    { title: 'Email', key: 'insuredEmail', colValue: 5 },
                    { title: 'Địa chỉ', key: 'insuredAddress', colValue: 5, },
                    { title: undefined, colValue: 24, key: 'certUrl', showCertLink: true},
                ]);
                break;
            case 'home-care': // đã xong
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 },
                ]);
                setInsuredInformation([
                    { title: 'Họ và tên', value: detailOrder?.buyerInfo?.buyerName, colValue: 5, capitalize: true },
                    { title: 'Ngày sinh', value: detailOrder?.buyerInfo?.buyerDob, colValue: 5 },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.buyerInfo?.buyerPrivateId, colValue: 5, },
                    { title: 'Số điện thoại', value: detailOrder?.buyerInfo?.buyerPhone, colValue: 5 },
                    { title: 'Email', value: detailOrder?.buyerInfo?.buyerEmail, colValue: 4 },
                    { title: 'Tỉnh/thành phố', value: detailOrder?.buyerInfo?.provinceTitle, colValue: 5, capitalize: true },
                    { title: 'Quận/huyện', value: detailOrder?.buyerInfo?.districtTitle, colValue: 5, capitalize: true },
                    { title: 'Địa chỉ được bảo hiểm', value: detailOrder?.buyerInfo?.buyerAddress, colValue: 5, capitalize: true },
                ]);
                break;
            case 'nha-tu-nhan': // đã xong
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5 },
                    { title: 'Giá trị ngôi nhà', value: Helper.formatMoney(detailOrder?.orderInfo?.houseValue) + ' VNĐ', colValue: 5 },
                    { title: 'Tài sản bên trong ngôi nhà', value: detailOrder?.orderInfo?.assetValue, colValue: 5 },
                    { title: 'Công ty bảo hiểm', value: detailOrder?.orderInfo?.providerTitle, colValue: 4 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 5 },
                    { title: 'Mã căn hộ/ tên nhà', value: detailOrder?.orderInfo?.houseCode, colValue: 5, },
                    { title: 'Địa chỉ được bảo hiểm', value: detailOrder?.orderInfo?.houseAddress, colValue: 5 },
                    { title: 'Nhà đang vay ngân hàng', value: detailOrder?.orderInfo?.bankLoan, colValue: 5 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 4 },
                    {
                        title: undefined,
                        value:
                            <div style={{display:'flex'}}>
                                <div style={{marginRight: 5}}>
                                    {
                                        FileViewAndImage('images', detailOrder?.orderInfo?.imageFrame, 'Hình ảnh khung nhà')

                                    }
                                </div>
                                <div>
                                    {
                                        FileViewAndImage('images', detailOrder?.orderInfo?.imageAssets, 'Hình ảnh bên trong nhà')

                                    }
                                </div>
                            </div>

                        ,
                        colValue: 24
                    }
                ]);
                setShowOwnership(detailOrder?.coOwner?.length > 0 ? true : false);
                setInsuredInformation([
                    { title: 'Họ và tên', value: detailOrder?.buyerInfo?.buyerName, colValue: 5, capitalize: true },
                    { title: 'Ngày sinh', value: detailOrder?.buyerInfo?.buyerDob, colValue: 5 },
                    { title: 'Giới tính', value: detailOrder?.buyerInfo?.buyerGender, colValue: 5 },
                    { title: 'CCCD / hộ chiếu', value: detailOrder?.buyerInfo?.buyerPrivateId, colValue: 5 },
                    { title: 'Số điện thoại', value: detailOrder?.buyerInfo?.buyerPhone, colValue: 4, },
                    { title: 'Email', value: detailOrder?.buyerInfo?.buyerEmail, colValue: 5 },
                    { title: 'Địa chỉ nhận thư tín', value: detailOrder?.buyerInfo?.buyerAddress, colValue: 5 },
                ]);
                break;
            default:
                // Cho những sản phẩm chưa có trong thiết kế
                setOrderInformation([
                    { title: 'Loại bảo hiểm', value: detailOrder?.orderInfo?.categoryTitle, colValue: 5 },
                    { title: 'Sản phẩm', value: detailOrder?.orderInfo?.productTitle, colValue: 5, },
                    { title: 'Nhà BH', value: detailOrder?.providerTitle, colValue: 5, },
                    { title: 'Gói bảo hiểm', value: detailOrder?.orderInfo?.packageName, colValue: 5 },
                    { title: 'Thời hạn bảo hiểm', value: detailOrder?.orderInfo?.insuranceDuration, colValue: 4 },
                    { title: 'Mã đơn hàng', value: detailOrder?.orderInfo?.code, colValue: 5 },
                    { title: 'Giấy chứng nhận BH', value: FileViewAndImage('link', detailOrder?.orderInfo?.certLink ? [detailOrder?.orderInfo?.certLink] : undefined), colValue: 19 },
                ]);
                setShowBuyer(true);
                setInsuredInformation([]);
                break;
        }
    }

    const FileViewAndImage = (type, arr, title) => {
        switch (type) {
            case 'link':
                return (
                    arr?.length > 0 ?
                        <div>
                            {
                                arr?.map((item) => (
                                    <div style={{ gap: 5, display: 'flex', alignItems: 'center', marginBottom: 10, }}>
                                        <img src={FileAttach} width={17} />
                                        <a style={{ color: '#343a40', textDecoration: 'underline' }} href={item} target="_blank">
                                            <div>{item}</div>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        :
                        <div>-</div>
                )
            case 'additionalBenefits':
                return (
                    arr?.length > 0 ?
                        <div>
                            {
                                arr?.map((item) => (
                                    <div style={{ gap: 5, display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                        <img src={ICKichhoat} width={17} />
                                        <div>{item}</div>
                                    </div>
                                ))
                            }
                        </div>
                        :
                        <div>-</div>
                )
            case 'images':
                return (
                    arr?.length > 0 &&
                    <ViewImageAndFile listImage={arr} listFile={[]} title={title} />
                )
            default:
                break;
        }
    }

    const truncateMiddle = (str, frontLen = 4, backLen = 4) => {
        if (str?.length <= frontLen + backLen) return str;
        return `${str?.slice(0, frontLen)}...${str?.slice(-backLen)}`;
    };

    const headers = [
        { title: "Thành viên đăng", align: 'left' },
        { title: "Hình ảnh", align: 'left' },
        { title: "Tiêu đề", align: 'left' },
        { title: "Loại bài viết", align: 'center' },
        { title: "Sản phẩm", align: 'left' },
        { title: "Ngày tạo đơn", align: 'center' },
        { title: "ID bài viết mẫu", align: 'center' },
        { title: "Trạng thái", align: 'center' },
    ];

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 30, fontSize: 16, marginBottom: 30 }}>
                <div
                    onClick={() => {
                        goStep(1);
                        navigate('/order');
                        localStorage.removeItem('dataDetailOrderAff');
                    }}>
                    <img src={Arrows} width={32} style={{ marginRight: 10, cursor: 'pointer' }} /></div>
                <div style={{ cursor: 'pointer' }} onClick={() => {
                    goStep(1);
                    navigate('/order');
                    localStorage.removeItem('dataDetailOrderAff');
                }}>Quản lý đơn</div>
                <>
                    <div style={{ fontSize: 14, color: '#969696', margin: '0px 10px' }}>{'>'}</div>
                    <div
                        onClick={() => {
                            goStep(1);
                            navigate('/order');
                            localStorage.removeItem('dataDetailOrderAff');
                        }}
                        style={{ cursor: 'pointer' }}>{detailOrder?.orderInfo?.productTitle || 'Sản phẩm'}</div>
                </>
                <>
                    <div style={{ fontSize: 14, color: '#969696', margin: '0px 10px' }}>{'>'}</div>
                    <div>Xem chi tiết</div>
                </>
            </div>
            <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0px 15px" }}>
                <thead>
                    <tr>
                        {
                            headers.map((item, index) => (
                                <th key={index} style={{ fontSize: 11, textAlign: item.align, fontWeight: 400, borderBottom: '0.5px solid #969696', paddingBottom: 5, paddingLeft: index === 0 ? 10 : '' }}>{item.title}</th>
                            ))
                        }
                    </tr>
                </thead>

                <tbody>
                    <tr style={{ background: '#ffffff', boxShadow: "0px 2px 2px 2px #0000001F", borderRadius: 8 }}>
                        <td style={{ textAlign: 'left', padding: '15px 10px', borderRadius: "8px 0px 0px 8px", width: 180 }}>
                            <div style={{ ...styles.textRowCenter, justifyContent: 'flex-start' }}>
                                <img style={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: '50%',
                                    boxShadow: "0px 0px 0px 2px #09BAFD",
                                    border: "3px solid #ffffff",
                                }} src={detailOrder?.memberArticle?.avatar} alt="avatar" />
                                <div style={{ textAlign: 'left' }}><b>{detailOrder?.memberArticle?.fullname}</b></div>
                            </div>
                        </td>
                        <td style={{ textAlign: 'left', width: 70 }}>
                            <img src={detailOrder?.memberArticle?.thumbnailImageUrl} alt="product" style={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "60px", height: "60px", borderRadius: 8
                            }} />
                        </td>
                        <td style={{ textAlign: 'left', maxWidth: 100 }}>
                            <div style={{ padding: '5px 0px' }}>{detailOrder?.memberArticle?.title}</div>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <span>{detailOrder?.memberArticle?.articleType}</span>
                        </td>
                        <td style={{ textAlign: 'left' }}>
                            <span>{detailOrder?.orderInfo?.productTitle}</span>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <span>{detailOrder?.memberArticle?.orderCreatedAt}</span>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <Popover placement="top" title={""} content={detailOrder?.memberArticle?.uid}>
                                <span>
                                    {truncateMiddle(detailOrder?.memberArticle?.uid)}
                                </span>
                            </Popover>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            {
                                detailOrder?.statusTitle &&
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: detailOrder?.statusColor}}>
                                    {/* <StatusWidget statusId={detailOrder?.status} /> */}
                                    {detailOrder?.statusTitle}
                                </div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style={{ marginTop: 0 }}>
                {/* Thông tin đơn hàng */}
                <div style={styles.containerForm}>
                    <Typography.Title level={3} style={styles.Title}>
                        Thông tin đơn hàng
                    </Typography.Title>
                    <div>
                        <Row gutter={[5, 10]} style={styles.FormInfor}>
                            {
                                (orderInformation || []).map((item) => (
                                    (
                                        <>
                                            {
                                                (!item.viewOrder) &&
                                                <Col key={item?.value} xs={item.colValue} style={styles.Infor}>
                                                    <h4 className={item.title ? "order-title" : ''}>{item.title}</h4><br />
                                                    <div style={styles.TextInfor}>{item.value}</div>
                                                </Col>
                                            }
                                        </>
                                    )
                                ))
                            }
                        </Row>
                    </div>
                    <div style={{ marginTop: '20px', display: 'flex', gap: 35 }}>
                        <div style={styles.fees}>
                            <span style={{ fontSize: '16px', fontWeight: 400, color: '#343a40' }}>Tổng phí bảo hiểm:</span>
                            <span style={{ fontSize: '16px', fontWeight: 500, color: '#003478' }}>{Helper.formatMoney(detailOrder?.orderInfo?.fees)} <span style={{ fontWeight: 400, color: '#969696' }}> VNĐ</span></span>
                        </div>
                        <div style={styles.fees}>
                            <span style={{ fontSize: '16px', fontWeight: 400, color: '#343a40' }}>Lương doanh thu:</span>
                            <span style={{ fontSize: '16px', fontWeight: 500, color: '#003478' }}>{Helper.formatMoney(detailOrder?.orderInfo?.commission) || 0} <span style={{ fontWeight: 400, color: '#969696' }}> VNĐ</span></span>
                        </div>
                    </div>
                </div>

                {/* Thông tin  */}
                <div style={{ ...styles.containerForm, marginTop: '20px' }}>
                    {
                        showBuyer &&
                        <div className="nguoimuabaohiem" style={{ marginBottom: 35 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography.Title level={3} style={styles.Title}>
                                    Thông tin người mua bảo hiểm
                                </Typography.Title>
                            </div>
                            <Row style={styles.FormInfor} gutter={[16, 16]}>
                                <Col xs={5} sm={5} md={5} lg={5} style={styles.Infor}>
                                    <h4 className="order-title">Họ và tên</h4><br />
                                    <div style={{ ...styles.TextInfor, textTransform: 'capitalize' }}>{detailOrder?.buyerInfo?.buyerName}</div>
                                </Col>
                                <Col xs={5} sm={5} md={5} lg={5} style={styles.Infor}>
                                    <h4 className="order-title">Ngày sinh</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerDob}</div>
                                </Col>
                                <Col xs={5} sm={5} md={5} lg={5} style={styles.Infor}>
                                    <h4 className="order-title">Giới tính</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerGender}</div>
                                </Col>
                                <Col xs={5} sm={5} md={5} lg={5} style={styles.Infor}>
                                    <h4 className="order-title">CCCD / hộ chiếu</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerPrivateId}</div>
                                </Col>
                                <Col xs={3} sm={3} md={3} lg={3} style={styles.Infor}>
                                    <h4 className="order-title">Số điện thoại</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerPhone}</div>
                                </Col>
                            </Row>
                            <Row style={styles.FormInfor} gutter={[16, 16]}>
                                <Col xs={5} sm={5} md={5} lg={5} style={styles.Infor}>
                                    <h4 className="order-title">Email</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerEmail}</div>
                                </Col>
                                <Col xs={10} sm={10} md={10} lg={10} style={styles.Infor}>
                                    <h4 className="order-title">Địa chỉ</h4><br />
                                    <div style={styles.TextInfor}>{detailOrder?.buyerInfo?.buyerAddress}</div>
                                </Col>
                            </Row>
                        </div>
                    }
                    <div className="nguoiduocbaohiem" style={{ display: insuredInformation.length === 0 ? 'none' : '' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 25 }}>
                            <Typography.Title level={3} style={styles.Title}>
                                Thông tin người được bảo hiểm
                            </Typography.Title>
                            {
                                detailOrder?.orderInfo?.certLink &&
                                <Button
                                    icon={<img src={View} style={{ width: '15px', marginTop: '5px' }} />}
                                    style={{ borderRadius: '5px', padding: '7px 11px', background: '#f0f2f5', color: '#343a40', border: 'none' }}
                                    onClick={() => window.open(detailOrder?.orderInfo?.certLink, '_blank')}
                                >
                                    Xem hợp đồng bảo hiểm
                                </Button>
                            }
                        </div>
                        {/* Người được bảo hiểm là người mua */}
                        {
                            insuredPeoples?.length === 0 &&
                            <div style={{ padding: '15px', background: '#f8f9fa', borderRadius: '16px', marginBottom: 30 }}>
                                <Row style={styles.FormInfor} gutter={[16, 25]}>
                                    {
                                        insuredInformation.map((item) => (
                                            <>
                                                {
                                                    (!item?.showCertLink && !item?.showNote) &&
                                                    <Col xs={item.colValue} style={{ ...styles.Infor, marginTop: -15, wordWrap: 'break-word' }}>
                                                        <h4 className="order-title">{item.title}</h4><br />
                                                        <div style={{ ...styles.TextInfor, textTransform: item?.capitalize ? 'capitalize' : '' }}>{item.value}</div>
                                                    </Col>
                                                }
                                                {
                                                    item?.showCertLink &&
                                                    <Col xs={item.colValue} style={styles.Infor}>
                                                        <h4>
                                                            <Button
                                                                icon={<img src={View} style={{ width: '15px', marginTop: '5px' }} />}
                                                                style={{ borderRadius: '5px', padding: '7px 11px', background: '#f0f2f5', color: '#343a40', border: 'none' }}
                                                            >
                                                                Xem hợp đồng bảo hiểm
                                                            </Button>
                                                        </h4>
                                                    </Col>
                                                }
                                                {
                                                    item?.showNote &&
                                                    <Col xs={item.colValue} style={styles.Infor}>
                                                        <div style={{ color: 'red' }}><i>{item.title}</i></div>
                                                    </Col>
                                                }
                                            </>
                                        ))
                                    }
                                </Row>
                            </div>
                        }
                        {/* Luồng nhiều người được bảo hiểm */}
                        {
                            insuredPeoples?.length > 0 &&
                            insuredPeoples?.map((data) => (
                                <div style={{ padding: '15px', background: '#f8f9fa', borderRadius: '16px', marginBottom: 30 }}>
                                    <Row style={styles.FormInfor} gutter={[16, 25]}>
                                        {
                                            insuredInformation.map((item) => (
                                                <>
                                                    {
                                                        (!item?.showCertLink && !item?.showNote) &&
                                                        <Col xs={item.colValue} style={{ ...styles.Infor, marginTop: -15, wordWrap: 'break-word' }}>
                                                            <h4 className="order-title">{item.title}</h4><br />
                                                            <div style={{ ...styles.TextInfor, textTransform: item?.capitalize ? 'capitalize' : '' }}>{data[item.key] || '-'}</div>
                                                        </Col>
                                                    }
                                                    {
                                                        item?.showCertLink &&
                                                        <Col xs={item.colValue} style={styles.Infor}>
                                                            <h4>
                                                                <Button
                                                                    onClick={()=> window.open(data?.certUrl,'_blank')}
                                                                    icon={<img src={View} style={{ width: '15px', marginTop: '5px' }} />}
                                                                    style={{ borderRadius: '5px', padding: '7px 11px', background: '#f0f2f5', color: '#343a40', border: 'none' }}
                                                                >
                                                                    Xem hợp đồng bảo hiểm
                                                                </Button>
                                                            </h4>
                                                        </Col>
                                                    }
                                                    {
                                                        item?.showNote &&
                                                        <Col xs={item.colValue} style={styles.Infor}>
                                                            <div style={{ color: 'red' }}><i>{data[item.key]}</i></div>
                                                        </Col>
                                                    }
                                                </>
                                            ))
                                        }
                                    </Row>
                                </div>
                            ))
                        }
                    </div>

                    {/* Người đồng sở hữu */}
                    {
                        showOwnership &&
                        <div className="nguoidongsohuu">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 25 }}>
                                <Typography.Title level={3} style={styles.Title}>
                                    Thông tin người đồng sở hữu căn nhà
                                </Typography.Title>
                            </div>
                            <Row gutter={[20, 20]}>
                                {
                                    (detailOrder?.coOwner || []).map((data, index) => (
                                        <Col xs={12}>
                                            <div style={{ padding: '15px', background: '#f8f9fa', borderRadius: '16px', width: '100%' }}>
                                                <Row key={index} style={styles.FormInfor} gutter={[16, 25]}>
                                                    <Col xs={8} style={{ ...styles.Infor, marginTop: -15, wordWrap: 'break-word' }}>
                                                        <h4 className="order-title">Họ và tên</h4><br />
                                                        <div style={{ ...styles.TextInfor, textTransform: 'capitalize' }}>{data?.insuredName}</div>
                                                    </Col>
                                                    <Col xs={8} style={{ ...styles.Infor, marginTop: -15, wordWrap: 'break-word' }}>
                                                        <h4 className="order-title">Ngày sinh</h4><br />
                                                        <div style={{ ...styles.TextInfor, textTransform: 'capitalize' }}>{data?.insuredDob}</div>
                                                    </Col>
                                                    <Col xs={8} style={{ ...styles.Infor, marginTop: -15, wordWrap: 'break-word' }}>
                                                        <h4 className="order-title">CCCD / hộ chiếu</h4><br />
                                                        <div style={{ ...styles.TextInfor, textTransform: 'capitalize' }}>{data?.insuredPrivarteId}</div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </div>
                    }
                </div>
            </div>
        </ >
    )
}
export default OrderDetail;

const styles = {
    textRowCenter: {
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        gap: 10
    },
    textRowLeft: {
        textAlign: "left",
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
        width: "100%",
    },
    containerForm: {
        background: '#ffffff',
        padding: '10px 30px 30px 30px',
        borderRadius: '8px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    },
    Title: {
        fontWeight: 500,
        fontSize: '20px',
        color: '#003478',
    },
    FormInfor: {
        display: 'flex',
        flexWrap: 'wrap',
        // gap: '16px',
        padding: '5px 5px 5px 5px'
    },
    Infor: {
        width: '100%'
    },
    TextInfor: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#343a40',
        marginTop: -10
    },
    fees: {
        display: 'flex',
        justifyContent: 'space-between',
        background: '#e6f2ff',
        padding: '12px 16px',
        borderRadius: '8px',
        width: '50%',
    }
}